import angular from "angular";
import { FormsUtility } from "./formsUtility";

angular.module('eCareVault.common.schemaForm')
    .factory('FormsUtilityFactory', [
        '$filter', '$q', 'FieldService', 'ApiAdapterService', 'APIService',
        'CacheService', '$uibModal', 'CommonService', 'moment',
        'SnackbarService', 'UtilityService', '$state', 'FormService',
        'PopUpService', 'SubjectService', '$interval', 'BroadcastService',
        'ConditionalModuleLoadService',
        function (
            $filter, $q, FieldService, ApiAdapterService, APIService,
            CacheService, $uibModal, CommonService, moment,
            SnackbarService, UtilityService, $state, FormService,
            PopUpService, SubjectService, $interval, BroadcastService,
            ConditionalModuleLoadService
        ) {
            // This object holds all the dependencies EXCEPT for $scope
            const dependencies = {
                $filter, $q, FieldService,
                $_api: ApiAdapterService,
                APIService,
                $_cache: CacheService,
                $uibModal,
                $_com: CommonService,
                moment,
                $_snack: SnackbarService,
                $_utilitySer: UtilityService,
                $state, FormService,
                PopUpService,
                SubjectService, $interval,
                BroadcastService,
                ConditionalModuleLoadService
            };

            // The factory returns an object with a 'create' method
            return {
                create: function (formName, scope) {
                    // Add the specific scope to the dependencies object for this instance
                    const instanceDependencies = {
                        ...dependencies,
                        $scope: scope
                    };
                    // Each call to 'create' returns a new instance
                    // of FormsUtility, passing in the collected dependencies.
                    return new FormsUtility(instanceDependencies, formName);
                }
            };
        }
    ]);